import { useUserQuery } from './useUserQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CoreUserUpdateMutationParams {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | null;
}

export const useCoreUserUpdateMutation = createMutationHook(
  'settings.teamPermissions.userUpdate',
  (params: CoreUserUpdateMutationParams) => ({
    coreUserUpdate: {
      __args: {
        id: params.id,
        input: {
          firstName: params.firstName,
          lastName: params.lastName,
          email: params.email,
          phoneNumber: params.phoneNumber,
        },
      },
      id: true,
      firstName: true,
      lastName: true,
      email: true,
      phoneNumber: true,
    },
  }),
  {
    invalidateQueries: [useUserQuery],
  },
);
